import _SegmentationUtil from './../_SegmentationUtil';

export default [function () {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'CampaignDataService', function ($element, $q, CampaignDataService) {
            return _SegmentationUtil($element, $q.resolve(CampaignDataService));
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/campaign/CampaignSegmentationDirective.js
// module id = 1065
// module chunks = 0